(() => {
  let disclosureId = 0;
  const desktopControllers = new WeakMap();
  const desktopBranches = '[data-g24-ae22-nav] .g24-ae22-root, [data-g24-ae22-nav] .g24-ae22-utility-details';
  const closeInnerBranches = scope => {
    scope.querySelectorAll('[data-g24-category-branch][open]').forEach(branch => {
      branch.open = false;
      const summary = branch.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', 'false');
      if (summary?.nextElementSibling) summary.nextElementSibling.inert = true;
    });
  };
  const setupGroupSwitcher = host => {
    if (host.dataset.g24SwitcherBound) return;
    const tablist = host.querySelector('[data-g24-ae24-tabs]');
    const tabs = [...host.querySelectorAll('[data-g24-ae24-tab]')];
    const panels = [...host.querySelectorAll('[data-g24-ae24-panel]')];
    const root = host.closest('.g24-ae22-root');
    if (!tablist || !root || !tabs.length || tabs.length !== panels.length) return;
    if (tabs.some((tab, index) => tab.hash !== `#${panels[index].id}`)) return;
    host.dataset.g24SwitcherBound = 'true';
    let activeIndex = 0;
    let hoverTimer;
    let pointerFocusedTab = false;
    const hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const cancelHover = () => clearTimeout(hoverTimer);
    const select = (index, focus = false) => {
      cancelHover();
      activeIndex = index;
      tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[position].hidden = !selected;
        panels[position].inert = !selected;
        if (!selected) closeInnerBranches(panels[position]);
      });
      if (focus) tabs[index].focus();
    };
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-orientation', 'vertical');
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        select(index, true);
        pointerFocusedTab = event.detail > 0;
      });
      tab.addEventListener('keydown', event => {
        pointerFocusedTab = false;
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key === ' ' || event.key === 'Enter') next = index;
        else if (event.key === 'ArrowRight') {
          event.preventDefault();
          [...panels[activeIndex].querySelectorAll('a[href],summary')].find(item => item.getClientRects().length && !item.closest('[inert]'))?.focus();
          return;
        }
        if (next === undefined) return;
        event.preventDefault();
        select(next, true);
      });
      tab.addEventListener('pointerenter', event => {
        cancelHover();
        if (event.pointerType !== 'mouse' || !hoverMedia.matches) return;
        hoverTimer = setTimeout(() => {
          if (!root.open || !hoverMedia.matches || tablist.contains(document.activeElement) || panels.some(panel => panel.contains(document.activeElement))) return;
          select(index);
        }, 70);
      });
      tab.addEventListener('pointerleave', cancelHover);
    });
    const releasePointerFocus = event => {
      if (event.pointerType !== 'mouse' || !pointerFocusedTab || !tablist.contains(document.activeElement)) return;
      pointerFocusedTab = false;
      root.querySelector(':scope > summary')?.focus({ preventScroll: true });
    };
    host.addEventListener('pointermove', releasePointerFocus);
    host.addEventListener('pointerleave', releasePointerFocus);
    host.addEventListener('pointerleave', cancelHover);
    root.addEventListener('pointerleave', cancelHover);
    root.addEventListener('keydown', () => { pointerFocusedTab = false; });
    root.addEventListener('toggle', () => {
      cancelHover();
      if (!root.open) {
        pointerFocusedTab = false;
        if (host.contains(document.activeElement)) root.querySelector(':scope > summary')?.focus();
        closeInnerBranches(host);
        select(0);
      }
    });
    hoverMedia.addEventListener('change', cancelHover);
    select(0);
    host.dataset.g24Enhanced = 'true';
  };
  const connectDisclosure = (branch, summary) => {
    const panel = summary.nextElementSibling;
    if (!panel) return;
    if (!panel.id) panel.id = `G24AE22Disclosure-${++disclosureId}`;
    summary.setAttribute('aria-controls', panel.id);
    summary.setAttribute('aria-expanded', String(branch.open));
    panel.inert = !branch.open;
    branch.addEventListener('toggle', () => {
      panel.inert = !branch.open;
      summary.setAttribute('aria-expanded', String(branch.open));
      if (!branch.open) closeInnerBranches(branch);
    });
  };
  const setupCategoryBranches = scope => {
    scope.querySelectorAll('[data-g24-category-branch]').forEach(branch => {
      if (branch.dataset.g24CategoryBound) return;
      branch.dataset.g24CategoryBound = 'true';
      const summary = branch.querySelector(':scope > summary');
      connectDisclosure(branch, summary);
      branch.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || event.defaultPrevented || !branch.open || event.target.closest('[data-g24-category-branch][open]') !== branch) return;
        event.preventDefault();
        event.stopPropagation();
        summary.focus();
        closeInnerBranches(branch);
        branch.open = false;
        summary.setAttribute('aria-expanded', 'false');
        if (summary.nextElementSibling) summary.nextElementSibling.inert = true;
      });
    });
  };
  const samePageSection = event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return null;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return null;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search || !url.hash) return null;
    try { return document.getElementById(decodeURIComponent(url.hash.slice(1))); }
    catch { return null; }
  };
  const setup = () => {
    document.querySelectorAll('[data-g24-ae22-nav]').forEach(nav => {
      if (nav.dataset.g24Bound) return;
      nav.dataset.g24Bound = 'true';
      setupCategoryBranches(nav);
      nav.querySelectorAll('[data-g24-ae24-switcher]').forEach(setupGroupSwitcher);
      const branches = [...nav.querySelectorAll('.g24-ae22-root, .g24-ae22-utility-details')];
      const hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      let keyboardActive = false;
      branches.forEach(branch => {
        const summary = branch.querySelector(':scope > summary');
        const panel = summary.nextElementSibling;
        let openTimer, closeTimer;
        let pointerInside = false;
        let hoverSuppressed = false;
        const cancelTimers = () => {
          clearTimeout(openTimer);
          clearTimeout(closeTimer);
        };
        const setOpen = open => {
          branch.open = open;
          summary.setAttribute('aria-expanded', String(open));
          if (panel) panel.inert = !open;
          if (!open) closeInnerBranches(branch);
        };
        const close = (suppress = false) => {
          cancelTimers();
          if (suppress && pointerInside) hoverSuppressed = true;
          setOpen(false);
        };
        const open = () => {
          document.querySelectorAll(desktopBranches).forEach(other => {
            if (other !== branch) desktopControllers.get(other)?.close();
          });
          setOpen(true);
        };
        const scheduleClose = () => {
          cancelTimers();
          closeTimer = setTimeout(() => {
            if (!pointerInside && !nav.matches(':hover') && !(keyboardActive && branch.contains(document.activeElement))) close();
          }, 350);
        };
        desktopControllers.set(branch, { close, open, cancelTimers, scheduleClose });
        connectDisclosure(branch, summary);
        branch.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(branch.open));
          if (branch.open) document.querySelectorAll('[data-g24-ae22-nav] .g24-ae22-root[open], [data-g24-ae22-nav] .g24-ae22-utility-details[open]').forEach(other => {
            if (other !== branch) desktopControllers.get(other)?.close();
          });
        });
        branch.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse' || !hoverMedia.matches) return;
          pointerInside = true;
          cancelTimers();
          if (hoverSuppressed || branch.open) return;
          openTimer = setTimeout(() => {
            const focusedPanel = [...document.querySelectorAll('[data-g24-ae22-nav] .g24-ae22-root[open] > summary + *, [data-g24-ae22-nav] .g24-ae22-utility-details[open] > summary + *')]
              .some(otherPanel => otherPanel !== panel && otherPanel.contains(document.activeElement));
            if (pointerInside && !hoverSuppressed && hoverMedia.matches && !focusedPanel) {
              keyboardActive = false;
              open();
            }
          }, 60);
        });
        branch.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse' || !hoverMedia.matches) return;
          pointerInside = false;
          hoverSuppressed = false;
          cancelTimers();
          scheduleClose();
        });
        branch.addEventListener('pointerdown', () => { keyboardActive = false; });
        summary.addEventListener('click', () => {
          cancelTimers();
          if (branch.open && pointerInside) hoverSuppressed = true;
        });
        hoverMedia.addEventListener('change', () => {
          pointerInside = false;
          hoverSuppressed = false;
          close();
        });
      });
      nav.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !hoverMedia.matches) return;
        branches.forEach(branch => { if (branch.open) desktopControllers.get(branch)?.cancelTimers(); });
      });
      nav.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse' || !hoverMedia.matches) return;
        branches.forEach(branch => { if (branch.open) desktopControllers.get(branch)?.scheduleClose(); });
      });
      nav.addEventListener('keydown', event => {
        keyboardActive = true;
        const branch = event.target.closest('.g24-ae22-root, .g24-ae22-utility-details');
        if (branch) desktopControllers.get(branch)?.cancelTimers();
        if (event.key === 'ArrowDown' && branch && event.target === branch.querySelector(':scope > summary')) {
          event.preventDefault();
          desktopControllers.get(branch)?.open();
          branch.querySelector('a')?.focus();
        }
      });
      nav.addEventListener('click', event => {
        const section = samePageSection(event);
        if (!section) return;
        document.querySelectorAll(desktopBranches).forEach(branch => { desktopControllers.get(branch)?.close(); });
        section.focus({ preventScroll: true });
      });
      nav.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (!nav.contains(document.activeElement)) branches.forEach(branch => { desktopControllers.get(branch)?.close(); });
      }));
    });
    document.querySelectorAll('[data-g24-ae22-mobile]').forEach(host => {
      if (host.dataset.g24Bound) return;
      host.dataset.g24Bound = 'true';
      const opener = host.querySelector('.g24-ae22-open');
      const drawer = host.querySelector('.g24-ae22-drawer');
      setupCategoryBranches(drawer);
      const closer = host.querySelector('.g24-ae22-close');
      const backdrop = host.querySelector('.g24-ae22-backdrop');
      let maskedElements = [];
      let bodyWasLocked = false;
      let rootWasLocked = false;
      const maskBackground = () => {
        let activeBranch = drawer;
        while (activeBranch.parentElement && activeBranch !== document.body) {
          [...activeBranch.parentElement.children].forEach(sibling => {
            if (sibling !== activeBranch && sibling !== backdrop && !sibling.inert) {
              sibling.inert = true;
              maskedElements.push(sibling);
            }
          });
          activeBranch = activeBranch.parentElement;
        }
      };
      const restoreBackground = () => {
        maskedElements.forEach(element => { element.inert = false; });
        maskedElements = [];
      };
      const focusable = () => [...drawer.querySelectorAll('a,button,summary,input,select,[tabindex="0"]')].filter(item => item.getClientRects().length && !item.disabled && item.tabIndex >= 0 && !item.closest('[inert]'));
      const close = () => {
        drawer.hidden = true;
        backdrop.hidden = true;
        opener.setAttribute('aria-expanded', 'false');
        if (!bodyWasLocked) document.body.classList.remove('g24-ae22-lock');
        if (!rootWasLocked) document.documentElement.classList.remove('g24-ae22-lock');
        restoreBackground();
        drawer.querySelectorAll('details[open]').forEach(item => { item.open = false; });
        if (opener.getClientRects().length) opener.focus();
        else host.closest('header')?.querySelector('.header__heading-link')?.focus();
      };
      opener.addEventListener('click', () => {
        drawer.hidden = false;
        backdrop.hidden = false;
        opener.setAttribute('aria-expanded', 'true');
        bodyWasLocked = document.body.classList.contains('g24-ae22-lock');
        rootWasLocked = document.documentElement.classList.contains('g24-ae22-lock');
        document.body.classList.add('g24-ae22-lock');
        document.documentElement.classList.add('g24-ae22-lock');
        closer.focus();
        maskBackground();
      });
      drawer.addEventListener('click', event => {
        const section = samePageSection(event);
        if (!section) return;
        close();
        section.focus({ preventScroll: true });
      });
      closer.addEventListener('click', close);
      backdrop.addEventListener('click', close);
      drawer.querySelectorAll('details:not([data-g24-category-branch])').forEach(branch => {
        const summary = branch.querySelector(':scope > summary');
        connectDisclosure(branch, summary);
        branch.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(branch.open));
          if (branch.open && branch.classList.contains('g24-ae22-mobile-root')) {
            drawer.querySelectorAll('.g24-ae22-mobile-root[open]').forEach(other => { if (other !== branch) other.open = false; });
          }
        });
      });
      drawer.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !event.defaultPrevented) {
          if (event.target.closest('localization-form')?.querySelector('[aria-expanded="true"]')) return;
          event.preventDefault();
          close();
        }
        if (event.key === 'Tab') {
          const items = focusable();
          const first = items[0], last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', event => { if (event.matches && !drawer.hidden) close(); });
    });
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-g24-ae22-nav]')) document.querySelectorAll(desktopBranches).forEach(branch => { desktopControllers.get(branch)?.close(); });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || event.defaultPrevented) return;
    document.querySelectorAll(desktopBranches).forEach(branch => {
      const wasOpen = branch.open;
      const hadFocus = branch.contains(document.activeElement);
      desktopControllers.get(branch)?.close(true);
      if (wasOpen && hadFocus) branch.querySelector('summary').focus();
      if (wasOpen) event.preventDefault();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
